<template>
  <div class="read-more">
    <span v-if="!isExpanded">{{ truncatedText }}</span>
    <span v-else>{{ text }}</span>
    <button
      v-if="shouldShowToggle"
      type="button"
      class="read-more-toggle"
      @click="toggle"
    >
      {{ isExpanded ? lessStr : moreStr }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ReadMore',
  props: {
    text: {
      type: String,
      default: ''
    },
    maxChars: {
      type: Number,
      default: 100
    },
    moreStr: {
      type: String,
      default: 'Read more'
    },
    lessStr: {
      type: String,
      default: 'Read less'
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    shouldShowToggle() {
      return this.text && this.text.length > this.maxChars;
    },
    truncatedText() {
      if (!this.text) return '';
      if (this.text.length <= this.maxChars) return this.text;
      return this.text.substring(0, this.maxChars) + '...';
    }
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
    }
  }
};
</script>

<style scoped>
.read-more-toggle {
  margin-left: 5px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;
  text-decoration: underline;
}
</style>
